import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'hooks/stateHooks';
import { getModulesRequireAuth } from 'slices/configSlice';
import CustomButton from 'components/common/button/CustomButton';
import {
	AWAITING_ACION_REPORT_TYPE,
	AWAITING_ACION_TYPES,
	AWAITING_ACTIONS_TYPES,
	MODE_VALUES,
	MODULE_IDS,
	PASSWORD_VERIFICATION_TRANSACTIONS,
} from 'utils/enum';
import { getPasswordVerificationAction } from 'utils/utils';
import CustomLoader from 'components/common/loader/CustomLoader';

const RejectButton = ({
	item,
	setAction,
	handleReject,
	setPasswordVerificationActions,
	setPasswordVerificationTransactions,
	setIsPasswordVerification,
	loader,
	loaderType,
	// setLoader,
	setLoaderType,
	disabled,
}) => {
	const { t } = useTranslation('dashboard');

	const modulesRequireAuth = useAppSelector(getModulesRequireAuth);

	const handleAwaitReject = () => {
		// setLoader(true);
		setLoaderType(AWAITING_ACION_TYPES.REJECT);
		const message = 'Rejected';
		setAction(MODE_VALUES.REJECT);

		// PRODUCT ORDER
		if (item?.typeId === AWAITING_ACTIONS_TYPES.PRODUCT_ORDER) {
			if (modulesRequireAuth.includes(MODULE_IDS.PRODUCT_ORDER_MANAGEMENT)) {
				setIsPasswordVerification(true);
				setPasswordVerificationTransactions(
					PASSWORD_VERIFICATION_TRANSACTIONS.PRODUCTORDER,
				);
				setPasswordVerificationActions(getPasswordVerificationAction(item, true));
			} else {
				handleReject(message);
			}
		}
		// PO WEBLINK
		else if (item?.typeId === AWAITING_ACTIONS_TYPES.PO_WEBLINK) {
			if (modulesRequireAuth.includes(MODULE_IDS.PRODUCT_ORDER_MANAGEMENT)) {
				setIsPasswordVerification(true);
				setPasswordVerificationTransactions(PASSWORD_VERIFICATION_TRANSACTIONS.POWEBLINK);
				setPasswordVerificationActions(getPasswordVerificationAction(item, true));
			} else {
				handleReject(message);
			}
		}
		// PRODUCT
		else if (item?.typeId === AWAITING_ACTIONS_TYPES.PRODUCT) {
			if (modulesRequireAuth.includes(MODULE_IDS.PRODUCT_MANAGEMENT)) {
				setIsPasswordVerification(true);
				setPasswordVerificationTransactions(PASSWORD_VERIFICATION_TRANSACTIONS.PRODUCT);
				setPasswordVerificationActions(getPasswordVerificationAction(item, true));
			} else {
				handleReject(message);
			}
		}
		// PRODUCT WEBLINK
		else if (item?.typeId === AWAITING_ACTIONS_TYPES.PRODUCT_WEBLINK) {
			if (modulesRequireAuth.includes(MODULE_IDS.PRODUCT_MANAGEMENT)) {
				setIsPasswordVerification(true);
				setPasswordVerificationTransactions(
					PASSWORD_VERIFICATION_TRANSACTIONS.PRODUCTWEBLINK,
				);
				setPasswordVerificationActions(getPasswordVerificationAction(item, true));
			} else {
				handleReject(message);
			}
		}
		// WEBLINK VALIDATION
		else if (item?.typeId === AWAITING_ACTIONS_TYPES.WEBLINK_VALIDATION) {
			if (modulesRequireAuth.includes(MODULE_IDS.WEBLINK_VALIDATOR)) {
				setIsPasswordVerification(true);
				setPasswordVerificationTransactions(
					PASSWORD_VERIFICATION_TRANSACTIONS.WEBLINKVALIDATOR,
				);
				setPasswordVerificationActions(getPasswordVerificationAction(item, true));
			} else {
				handleReject(message);
			}
		}
		// REPORTS
		else if (item?.typeId === AWAITING_ACTIONS_TYPES.REPORT) {
			if (modulesRequireAuth.includes(MODULE_IDS.REPORTS)) {
				setIsPasswordVerification(true);
				setPasswordVerificationActions(getPasswordVerificationAction(item, true));

				if (item?.customName2 === AWAITING_ACION_REPORT_TYPE.AUDIT_LOG) {
					setPasswordVerificationTransactions(
						PASSWORD_VERIFICATION_TRANSACTIONS.AUDITLOG,
					);
				} else if (item?.customName2 === AWAITING_ACION_REPORT_TYPE.BATCH_REPORT) {
					setPasswordVerificationTransactions(
						PASSWORD_VERIFICATION_TRANSACTIONS.BATCHSUMMERYREPORT,
					);
				} else if (
					item?.customName2 === AWAITING_ACION_REPORT_TYPE.PRODUCT_BATCH_PACK_REPORT
				) {
					setPasswordVerificationTransactions(
						PASSWORD_VERIFICATION_TRANSACTIONS.BATCHDETAILSREPORT,
					);
				}
			} else {
				handleReject(message);
			}
		}
	};
	return (
		<CustomButton
			buttonClassName='dsb-btn reject'
			type='button'
			buttonName={
				loaderType === AWAITING_ACION_TYPES.REJECT && loader ? (
					<span className='loader-primary'>
						<CustomLoader />
					</span>
				) : (
					t('REJECT')
				)
			}
			handleClick={() => handleAwaitReject()}
			disabled={disabled}
		/>
	);
};

export default RejectButton;
